import CasDisplayField from "./CasDisplayField";

interface CasNotesFieldProps {
  value: string | JSX.Element;
  label?: string;
  className?: string;
  fullWidth?: boolean;
  onClick?: VoidFunction | null;
}

export default function CasNotesField({
  label = 'Notes',
  className = '',
  value,
  fullWidth,
  onClick = null,
}: CasNotesFieldProps) {
  return (
    <CasDisplayField
      className={`CasNotesField ${className}`}
      label={label}
      value={value}
      fullWidth={fullWidth}
      onClick={onClick}
    />
  );
}
